// extracted by mini-css-extract-plugin
export var addressFields = "_jg-0";
export var animationContainer = "_jg-1";
export var footer = "_jg-2";
export var lineItems = "_jg-3";
export var modalContent = "_jg-4";
export var orderName = "_jg-5";
export var strong = "_jg-6";
export var warning = "_jg-7";